module.exports = "<i class=\"icon-X\" ng-click=\"amTableCtrl.remove(rowObj)\"></i>"